import useSWR from 'swr';
import { OrderService } from '../../api';

const fetchAvailableDates = async (accountId: string, orderPageIds: string[], persons: number, lastDate?: string) => {
  return OrderService.getAvailableDatesMultipleWorkshops({
    account_id: accountId,
    order_page_ids: orderPageIds,
    persons,
    last_date: lastDate,
  });
};

export const useAvailableDates = (
  accountId: string,
  orderPageIds: string[],
  persons: number,
  allOrderPageIds?: string[],
  lastDate?: string,
) => {
  const effectiveOrderPageIds = orderPageIds.length === 0 ? allOrderPageIds || [] : orderPageIds;

  const { data, error, mutate } = useSWR(
    [accountId, effectiveOrderPageIds, persons, lastDate],
    () => fetchAvailableDates(accountId, effectiveOrderPageIds, persons, lastDate),
    {
      revalidateOnFocus: false,
      dedupingInterval: 0,
      refreshInterval: 0,
    },
  );

  return {
    availableDates: data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};
